/* eslint-disable @typescript-eslint/no-unused-vars */

import { DetailGetInterface } from "../SupplierFormCst/types";
import { ExpandMore, Delete, Edit } from "@mui/icons-material";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  IconButton,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

// Interface
interface DetailAccordionCstInterface {
  data: DetailGetInterface;
  index: number;
  onEdit?: (data: any, index: number) => void;
  onDelete?: (data: any) => void;
  isDetail?: boolean;
}

// eslint-disable-next-line no-empty-pattern
const DetailAccordionCst: React.FC<DetailAccordionCstInterface> = ({
  data,
  index,
  onEdit,
  onDelete,
  isDetail,
}) => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const { t } = useTranslation(["form"]);

  return (
    <>
      <Accordion
        sx={{
          mt: isDetail ? "0" : "1.5rem",
          border: `1px solid ${theme.palette.text.tertiary}`,
          borderRadius: "4px",
          "&.Mui-expanded": {
            mt: isDetail ? "0" : "1.5rem",
          },
          "&.Mui-disabled": {
            background: "transparent",
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{
            minHeight: "3rem",
            pl: "1.875rem",
            "&.Mui-expanded": {
              minHeight: "3rem",
            },
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
            "&.Mui-disabled": {
              opacity: 1,
            },
          }}
        >
          {t("detail-form.detail-label")} {index + 1}
        </AccordionSummary>
        <AccordionDetails>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              rowGap: "1rem",
              [theme.breakpoints.down("sm")]: {
                gridTemplateColumns: "1fr",
              },
            }}
          >
            <Box
              sx={{
                borderBottom: "1px solid white",
                p: "1rem",
              }}
            >
              <Typography fontWeight={600} mb={1}>
                {t("detail-form.country")}
              </Typography>
              <Typography>{data.country ? data.country : "-"}</Typography>
            </Box>
            <Box
              sx={{
                borderBottom: "1px solid white",
                p: "1rem",
              }}
            >
              <Typography fontWeight={600} mb={1}>
                {t("detail-form.province")}
              </Typography>
              <Typography>{data.province ? data.province : "-"}</Typography>
            </Box>
            <Box
              sx={{
                borderBottom: "1px solid white",
                p: "1rem",
              }}
            >
              <Typography fontWeight={600} mb={1}>
                {t("detail-form.city")}
              </Typography>
              <Typography>{data.city ? data.city : "-"}</Typography>
            </Box>
            <Box
              sx={{
                borderBottom: "1px solid white",
                p: "1rem",
              }}
            >
              <Typography fontWeight={600} mb={1}>
                {t("detail-form.postal_code")}
              </Typography>
              <Typography>
                {data.postal_code ? data.postal_code : "-"}
              </Typography>
            </Box>
            <Box
              sx={{
                borderBottom: "1px solid white",
                p: "1rem",
              }}
            >
              <Typography fontWeight={600} mb={1}>
                {t("detail-form.address")}
              </Typography>
              <Typography>{data.address ? data.address : "-"}</Typography>
            </Box>
            <Box
              sx={{
                borderBottom: "1px solid white",
                p: "1rem",
              }}
            >
              <Typography fontWeight={600} mb={1}>
                {t("detail-form.email")}
              </Typography>
              <Typography>{data.address ? data.email : "-"}</Typography>
            </Box>
            <Box
              sx={{
                borderBottom: "1px solid white",
                p: "1rem",
              }}
            >
              <Typography fontWeight={600} mb={1}>
                {t("detail-form.phone")}
              </Typography>
              <Typography>{data.address ? data.phone : "-"}</Typography>
            </Box>
            <Box
              sx={{
                borderBottom: "1px solid white",
                p: "1rem",
              }}
            >
              <Typography fontWeight={600} mb={1}>
                {t("detail-form.alternate_phone")}
              </Typography>
              <Typography>
                {data.address ? data.alternate_phone : "-"}
              </Typography>
            </Box>
            <Box
              sx={{
                borderBottom: "1px solid white",
                p: "1rem",
              }}
            >
              <Typography fontWeight={600} mb={1}>
                {t("detail-form.website")}
              </Typography>
              <Typography>{data.address ? data.website : "-"}</Typography>
            </Box>
          </Box>
          {!isDetail && (
            <Box
              sx={{
                mt: "2rem",
                mr: "1rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "20px",
                [theme.breakpoints.down("sm")]: {
                  flexDirection: "column",
                },
              }}
            >
              <IconButton
                aria-label="delete detail"
                onClick={() => onDelete && onDelete(data)}
                edge="end"
              >
                <Delete />
              </IconButton>
              <IconButton
                aria-label="edit detail"
                onClick={() => {
                  onEdit && onEdit(data, index);
                }}
                edge="end"
              >
                <Edit />
              </IconButton>
            </Box>
          )}
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default DetailAccordionCst;
